export const categories = [
  {
    slug: 'yingshi',
    name: '影视爆料',
    desc: '剧集电影开机、换角、补拍与片场动向，第一时间直击剧组背后。',
    icon: 'ri-movie-2-line',
    count: 42,
  },
  {
    slug: 'zongyi',
    name: '综艺现场',
    desc: '录制现场路透、赛制调整与嘉宾阵容变化，还原棚内的真实一刻。',
    icon: 'ri-live-line',
    count: 28,
  },
  {
    slug: 'yinyue',
    name: '音乐动态',
    desc: '巡演、音乐节与专辑计划的即时快讯，追踪舞台内外的每一次变动。',
    icon: 'ri-music-2-line',
    count: 19,
  },
  {
    slug: 'mingxing',
    name: '明星日常',
    desc: '路人偶遇、行程路透与团队回应，记录聚光灯之外的日常片段。',
    icon: 'ri-user-star-line',
    count: 36,
  },
  {
    slug: 'wanghong',
    name: '网红直播',
    desc: '直播间突发状况、人气主播动向与平台规则更新，一处看全。',
    icon: 'ri-vidicon-line',
    count: 23,
  },
  {
    slug: 'shishang',
    name: '品牌时尚',
    desc: '红毯造型、代言官宣与造型团队回应，解读每一次出圈瞬间。',
    icon: 'ri-shirt-line',
    count: 15,
  },
];